import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(dvr => ({
        value: dvr.id,
        label: dvr.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/hikvision/master-accounts', { params })

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/hikvision/master-accounts', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/hikvision/master-accounts/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/hikvision/master-accounts/${id}`)

      return data
    },
    async syncDvrs(_, params) {
      const { data } = await axios.post('v1/hikvision/master-accounts/discover-dvrs', params)

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
